import React, { useState, useEffect } from 'react';
import {
  Breadcrumb,
  BreadcrumbItem,
  OverflowMenu,
  OverflowMenuItem
} from 'carbon-components-react';

type propTypesBreadcrumbs = {
  breadcrumb: string;
  href: string;
};
const Breadcrumbs = ({ breadcrumb, href }: propTypesBreadcrumbs) => {
  const breadcrumbs = breadcrumb.split(',');
  const hrefs = href.replace(/\s+/g, '').split(',');

  const [isMobile, setIsMobile] = useState<boolean>(false);
  useEffect(() => {
    updateDimensions();
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  const updateDimensions = () => {
    const width = window.innerWidth;
    if (width > 576) {
      setIsMobile(false);
    } else {
      setIsMobile(true);
    }
  };

  return (
    <Breadcrumb noTrailingSlash={true}>
      {breadcrumbs.length ? (
        isMobile ? (
          <>
            <BreadcrumbItem href={hrefs[0]}>{breadcrumbs[0]}</BreadcrumbItem>
            {breadcrumbs.length > 2 ? (
              <BreadcrumbItem data-floating-menu-container>
                <OverflowMenu>
                  {breadcrumbs.map((breadcrumb: string, index: number) => {
                    if (index > 0 && index < breadcrumbs.length - 1)
                      return (
                        <OverflowMenuItem
                          key={`${breadcrumb}-${index}`}
                          href={hrefs[index]}
                          itemText={breadcrumb}
                        />
                      );
                  })}
                </OverflowMenu>
              </BreadcrumbItem>
            ) : null}
            <BreadcrumbItem href={hrefs[hrefs.length - 1]} isCurrentPage>
              {breadcrumbs[breadcrumbs.length - 1]}
            </BreadcrumbItem>
          </>
        ) : (
          breadcrumbs.map((breadcrumb: string, index: number) => {
            return (
              <BreadcrumbItem
                key={`${breadcrumb}-${index}`}
                href={hrefs[index]}
                isCurrentPage={index === breadcrumbs.length - 1}
              >
                {breadcrumb}
              </BreadcrumbItem>
            );
          })
        )
      ) : null}
    </Breadcrumb>
  );
};
export default Breadcrumbs;
